import { render, staticRenderFns } from "./DashboardGroups.vue?vue&type=template&id=63bb2af6"
import script from "./DashboardGroups.vue?vue&type=script&lang=js"
export * from "./DashboardGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports